// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o9-0";
export var animationContainer = "_o9-1";
export var itemPrice = "_o9-a";
export var itemizedContent = "_o9-9";
export var itemizedHeader = "_o9-7";
export var itemizedRow = "_o9-8";
export var itemizedSection = "_o9-6";
export var modalContent = "_o9-2";
export var orderName = "_o9-3";
export var refundOption = "_o9-4";
export var refundOptionsContainer = "_o9-5";
export var shippingLabel = "_o9-b";
export var totalRow = "_o9-c";